(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode('._FileExplorer_18occ_1{--header-height: 3.5rem;--sidebar-width: 10rem;--footer-height: 1.75rem;--scale: 1.15rem;display:flex;flex-direction:column;width:100%;height:100%}._Header_18occ_25{display:flex;gap:1rem;align-items:center;width:100%;height:var(--header-height);padding:1rem;background-color:var(--background-color-0)}._IconButton_18occ_45{--color: var(--foreground-color-0);position:relative;height:1.25rem;width:auto;padding:0;background:none;border:none;outline:none;aspect-ratio:1;cursor:pointer}._IconButton_18occ_45:after{content:"";position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff0;border-radius:var(--border-radius-99);transform:scale(1);transform-origin:center;transition:all var(--transition-duration-1) var(--ease-in-out-default)}._IconButton_18occ_45:hover:after,._IconButton_18occ_45:focus-visible:after{background-color:#ffffff1a;transform:scale(1.5)}._IconButton_18occ_45:disabled{--color: var(--background-color-1)}._IconButton_18occ_45 svg{height:100%}._IconButton_18occ_45 svg path{fill:var(--color);transition:fill var(--transition-duration-0) var(--ease-in-out-default)}._PathInput_18occ_137{flex:1;padding:.25rem .5rem;background-color:var(--background-color-2);border:none;border-radius:var(--border-radius-1);outline:none;font-family:inherit;font-size:inherit}._Body_18occ_159{flex:1;display:flex;width:100%;height:calc(100% - var(--header-height));background-color:var(--background-color-2)}._Sidebar_18occ_175{display:flex;gap:.25rem;flex-direction:column;min-width:calc(var(--sidebar-width) / 2);width:var(--sidebar-width);height:100%;max-width:50%;padding:.5rem;background-color:var(--background-color-1);resize:horizontal;overflow:hidden}._NavButton_18occ_203{display:flex;gap:.5rem;align-items:center;width:100%;padding:.5rem;background:none;border:none;border-radius:var(--border-radius-1);outline:none;cursor:pointer;transition:background-color var(--transition-duration-0) var(--ease-in-out-default)}._NavButton_18occ_203:hover,._NavButton_18occ_203:focus-visible{background-color:color-mix(in srgb,var(--background-color-0) 75%,transparent)}._NavButton_18occ_203 svg{height:1.35rem;aspect-ratio:1}._Main_18occ_249{--scale: inherit !important;position:relative;flex:1;display:flex;flex-wrap:wrap;align-content:flex-start;height:100%;padding:.5rem;padding-bottom:calc(.5rem + var(--footer-height));overflow:auto}._Footer_18occ_277{position:absolute;display:flex;justify-content:flex-start;align-items:center;bottom:0;left:0;width:100%;height:var(--footer-height);padding:0 .75rem;border-top:.25rem solid var(--background-color-0);background-color:var(--background-color-2)}._Footer_18occ_277 p{margin:0;font-size:.875em}._Selector_18occ_315{--footer-height: 4rem}._FileProperties_s5har_1{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;padding:1rem}._Icon_s5har_17{width:3rem;height:3rem}._Icon_s5har_17 div{width:inherit;height:inherit;object-fit:contain}._Icon_s5har_17 svg{max-width:100%;max-height:100%}._Section_s5har_49{--divider-width: .25rem;position:relative;display:flex;gap:.25rem;justify-content:flex-start;align-items:flex-start;flex-direction:column;width:100%;padding:1rem 0;padding-bottom:calc(1rem + var(--divider-width))}._Section_s5har_49:first-child{gap:.5rem;align-items:center;flex-direction:row;padding-top:0}._Section_s5har_49:first-child ._Line_s5har_91{font-size:1.25rem}._Section_s5har_49:not(:last-child):after{content:"";position:absolute;bottom:0;left:0;width:100%;height:var(--divider-width);border-radius:var(--border-radius-0);background-color:var(--background-color-0)}._Line_s5har_91{margin:0;text-align:left;padding-left:2rem;text-indent:-2rem}._AppIcon_s5har_135{display:inline-block;width:2rem;height:2rem;vertical-align:middle;margin-left:.5rem;margin-right:.25rem}._AppIcon_s5har_135 div{position:relative;width:inherit;height:inherit;object-fit:contain}._AppIcon_s5har_135 svg{position:absolute;top:0;left:0;max-width:100%;max-height:100%}')),document.head.appendChild(o)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import { utilStyles as L, VirtualFile as te, useSystemManager as W, WindowedModal as ne, ImagePreview as D, StorageManager as M, useVirtualRoot as oe, useWindowsManager as re, useHistory as se, useAlert as ce, useWindowedModal as ie, useContextMenu as O, Actions as U, ClickAction as x, Vector2 as b, Divider as ae, VirtualRoot as F, DialogBox as z, ModalsConfig as $, DirectoryList as le, CODE_EXTENSIONS as de, App as ue, AppsConfig as pe } from "@prozilla-os/core";
import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { useState as S, useCallback as me, useEffect as H } from "react";
import { FontAwesomeIcon as m } from "@fortawesome/react-fontawesome";
import { faDownload as he, faTrash as V, faCircleInfo as _e, faCaretLeft as Ne, faCaretRight as Ie, faArrowUp as ge, faPlus as xe, faSearch as fe, faCog as be, faHouse as Ee, faDesktop as ye, faImage as ve, faFileLines as Be } from "@fortawesome/free-solid-svg-icons";
const Ce = "_FileExplorer_18occ_1", Ae = "_Header_18occ_25", Pe = "_IconButton_18occ_45", Se = "_PathInput_18occ_137", Le = "_Body_18occ_159", Te = "_Sidebar_18occ_175", we = "_NavButton_18occ_203", ke = "_Main_18occ_249", De = "_Footer_18occ_277", Me = "_Selector_18occ_315", a = {
  FileExplorer: Ce,
  Header: Ae,
  IconButton: Pe,
  PathInput: Se,
  Body: Le,
  Sidebar: Te,
  NavButton: we,
  Main: ke,
  Footer: De,
  Selector: Me
};
function E({ onClick: o, icon: h, name: i }) {
  return /* @__PURE__ */ c(
    "button",
    {
      tabIndex: 0,
      className: `${a.NavButton} ${L.TextSemibold}`,
      onClick: o,
      children: [
        /* @__PURE__ */ e(m, { icon: h }),
        i
      ]
    }
  );
}
function Oe({ directory: o }) {
  const h = (i) => {
    const _ = i.target.files;
    _ != null && Array.from(_).forEach((p) => {
      const { name: u, extension: N } = te.splitId(p.name), r = new FileReader();
      r.onload = (I) => {
        const { result: y } = I.target;
        o.createFile(u, N, (l) => {
          l.setSource(y);
        });
      }, r.readAsDataURL(p);
    });
  };
  return /* @__PURE__ */ c("label", { title: "Import", tabIndex: 0, className: a.IconButton, children: [
    /* @__PURE__ */ e(
      "input",
      {
        type: "file",
        id: "import",
        multiple: !0,
        style: { display: "none" },
        onChange: h
      }
    ),
    /* @__PURE__ */ e(m, { icon: he })
  ] });
}
const G = {
  NONE: 0,
  SINGLE: 1,
  MULTIPLE: 2
}, Ue = "_FileProperties_s5har_1", Fe = "_Icon_s5har_17", ze = "_Section_s5har_49", $e = "_Line_s5har_91", He = "_AppIcon_s5har_135", d = {
  FileProperties: Ue,
  Icon: Fe,
  Section: ze,
  Line: $e,
  AppIcon: He
};
function Ve({ modal: o, params: h, file: i, ..._ }) {
  const { appsConfig: p } = W(), u = i.extension != null ? p.getAppByFileExtension(i.extension) : null;
  return /* @__PURE__ */ c(ne, { className: d.FileProperties, modal: o, params: h, ..._, children: [
    /* @__PURE__ */ c("span", { className: d.Section, children: [
      /* @__PURE__ */ e(D, { className: d.Icon, source: i.getIconUrl() }),
      /* @__PURE__ */ e("p", { className: `${d.Line} ${L.TextBold}`, children: i.id })
    ] }),
    /* @__PURE__ */ c("span", { className: d.Section, children: [
      /* @__PURE__ */ c("p", { className: d.Line, children: [
        "Type: ",
        i.getType()
      ] }),
      u != null && /* @__PURE__ */ c("span", { className: d.Line, children: [
        "Opens with:",
        /* @__PURE__ */ e(D, { className: d.AppIcon, source: u.iconUrl ?? "" }),
        u.name
      ] })
    ] }),
    /* @__PURE__ */ c("span", { className: d.Section, children: [
      /* @__PURE__ */ c("p", { className: d.Line, children: [
        "Location: ",
        i.path
      ] }),
      /* @__PURE__ */ c("p", { className: d.Line, children: [
        "Size: ",
        M.getByteSize(i.source ?? i.content),
        " bytes"
      ] }),
      /* @__PURE__ */ c("p", { className: d.Line, children: [
        "Size on drive: ",
        M.getByteSize(i.toString()),
        " bytes"
      ] })
    ] }),
    /* @__PURE__ */ e("span", { className: d.Section, children: /* @__PURE__ */ c("p", { className: d.Line, children: [
      "Attributes: ",
      i.isProtected ? "Protected" : "N/A"
    ] }) })
  ] });
}
function Ge({ app: o, path: h, selectorMode: i, Footer: _, onSelectionChange: p, onSelectionFinish: u }) {
  const N = _ != null && i != null && i !== G.NONE, r = oe(), I = re(), { windowsConfig: y } = W(), [l, v] = S(r == null ? void 0 : r.navigate(h ?? "~")), [Y, f] = S((l == null ? void 0 : l.path) ?? ""), [T] = S(!0), { history: B, stateIndex: w, pushState: k, undo: j, redo: K, undoAvailable: Q, redoAvailable: X } = se(l.path), { alert: q } = ce(), { openWindowedModal: C } = ie(), { onContextMenu: J } = O({
    Actions: (s) => /* @__PURE__ */ c(U, { ...s, children: [
      /* @__PURE__ */ e(x, { label: N ? "Select" : "Open", onTrigger: (t, n) => {
        if (N) {
          p == null || p({ files: [n.id], directory: l }), u == null || u();
          return;
        }
        I != null && n.open(I);
      } }),
      /* @__PURE__ */ e(x, { label: "Delete", icon: V, onTrigger: (t, n) => {
        n.delete();
      } }),
      /* @__PURE__ */ e(x, { label: "Properties", icon: _e, onTrigger: (t, n) => {
        C({
          title: `${n.id} ${y.titleSeparator} Properties`,
          iconUrl: n.getIconUrl(),
          size: new b(400, 500),
          Modal: (P) => /* @__PURE__ */ e(Ve, { file: n, ...P })
        });
      } })
    ] })
  }), { onContextMenu: Z } = O({
    Actions: (s) => /* @__PURE__ */ c(U, { ...s, children: [
      /* @__PURE__ */ e(x, { label: "Open", onTrigger: (t, n) => {
        g(n.linkedPath ?? n.name);
      } }),
      /* @__PURE__ */ e(ae, {}),
      /* @__PURE__ */ e(x, { label: "Delete", icon: V, onTrigger: (t, n) => {
        n.delete();
      } })
    ] })
  }), g = me((s, t = !1) => {
    if (s == null)
      return;
    l == null && (t = !0);
    const n = t ? r == null ? void 0 : r.navigate(s) : l.navigate(s);
    n != null && (v(n), f(n.root ? "/" : n.path), k(n.path));
  }, [l, k, r]);
  H(() => {
    if (B.length === 0)
      return;
    const s = B[w], t = r == null ? void 0 : r.navigate(s);
    t != null && (v(t), f(t.root ? "/" : t.path));
  }, [B, w, r]), H(() => {
    const s = (t) => {
      q({
        title: t.message,
        text: "You have exceeded the virtual drive capacity. Files and folders will not be saved until more storage is freed.",
        iconUrl: o == null ? void 0 : o.iconUrl,
        size: new b(300, 200),
        single: !0
      });
    };
    return r == null || r.on(F.EVENT_NAMES.error, s), () => {
      r == null || r.off(F.EVENT_NAMES.error, s);
    };
  }, []);
  const R = (s) => {
    f(s.target.value);
  }, ee = (s) => {
    let t = s.target.value;
    if (s.key === "Enter") {
      t === "" && (t = "~");
      const n = r == null ? void 0 : r.navigate(t);
      if (n == null) {
        C({
          title: "Error",
          iconUrl: o == null ? void 0 : o.iconUrl,
          size: new b(300, 150),
          Modal: (P) => /* @__PURE__ */ c(z, { ...P, children: [
            /* @__PURE__ */ c("p", { children: [
              'Invalid path: "',
              t,
              '"'
            ] }),
            /* @__PURE__ */ e("button", { "data-type": $.DIALOG_CONTENT_TYPES.closeButton, children: "Ok" })
          ] })
        });
        return;
      }
      v(n), f(n.root ? "/" : n.path);
    }
  }, A = l.getItemCount(T);
  return /* @__PURE__ */ c("div", { className: N ? `${a.FileExplorer} ${a.Selector}` : a.FileExplorer, children: [
    /* @__PURE__ */ c("div", { className: a.Header, children: [
      /* @__PURE__ */ e(
        "button",
        {
          title: "Back",
          tabIndex: 0,
          className: a.IconButton,
          onClick: () => {
            j();
          },
          disabled: !Q,
          children: /* @__PURE__ */ e(m, { icon: Ne })
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          title: "Forward",
          tabIndex: 0,
          className: a.IconButton,
          onClick: () => {
            K();
          },
          disabled: !X,
          children: /* @__PURE__ */ e(m, { icon: Ie })
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          title: "Up",
          tabIndex: 0,
          className: a.IconButton,
          onClick: () => {
            g("..");
          },
          disabled: l.isRoot != null && l.isRoot,
          children: /* @__PURE__ */ e(m, { icon: ge })
        }
      ),
      /* @__PURE__ */ e(
        "button",
        {
          title: "New",
          tabIndex: 0,
          className: a.IconButton,
          onClick: () => {
            C({
              title: "Error",
              iconUrl: o == null ? void 0 : o.iconUrl,
              size: new b(300, 150),
              Modal: (s) => /* @__PURE__ */ c(z, { ...s, children: [
                /* @__PURE__ */ e("p", { children: "This folder is protected." }),
                /* @__PURE__ */ e("button", { "data-type": $.DIALOG_CONTENT_TYPES.closeButton, children: "Ok" })
              ] })
            });
          },
          disabled: !l.canBeEdited,
          children: /* @__PURE__ */ e(m, { icon: xe })
        }
      ),
      /* @__PURE__ */ e(
        "input",
        {
          value: Y,
          type: "text",
          "aria-label": "Path",
          className: a.PathInput,
          tabIndex: 0,
          onChange: R,
          onKeyDown: ee,
          placeholder: "Enter a path..."
        }
      ),
      /* @__PURE__ */ e(Oe, { directory: l }),
      /* @__PURE__ */ e("button", { title: "Search", tabIndex: 0, className: a.IconButton, children: /* @__PURE__ */ e(m, { icon: fe }) }),
      /* @__PURE__ */ e("button", { title: "Settings", tabIndex: 0, className: a.IconButton, children: /* @__PURE__ */ e(m, { icon: be }) })
    ] }),
    /* @__PURE__ */ c("div", { className: a.Body, children: [
      /* @__PURE__ */ c("div", { className: a.Sidebar, children: [
        /* @__PURE__ */ e(E, { name: "Home", onClick: () => {
          g("~");
        }, icon: Ee }),
        /* @__PURE__ */ e(E, { name: "Desktop", onClick: () => {
          g("~/Desktop");
        }, icon: ye }),
        /* @__PURE__ */ e(E, { name: "Images", onClick: () => {
          g("~/Pictures");
        }, icon: ve }),
        /* @__PURE__ */ e(E, { name: "Documents", onClick: () => {
          g("~/Documents");
        }, icon: Be })
      ] }),
      /* @__PURE__ */ e(
        le,
        {
          directory: l,
          id: "main",
          className: a.Main,
          showHidden: T,
          onOpenFile: (s, t) => {
            if (s.preventDefault(), N)
              return void (u == null ? void 0 : u());
            const n = {};
            (t.extension === "md" || t.extension != null && de.includes(t.extension)) && (n.mode = "view"), I == null || I.openFile(t, n);
          },
          onOpenFolder: (s, t) => {
            g(t.linkedPath ?? t.name);
          },
          onContextMenuFile: J,
          onContextMenuFolder: Z,
          allowMultiSelect: i !== G.SINGLE,
          onSelectionChange: p
        }
      )
    ] }),
    N ? /* @__PURE__ */ e("div", { className: a.Footer, children: /* @__PURE__ */ e(_, {}) }) : /* @__PURE__ */ e("span", { className: a.Footer, children: /* @__PURE__ */ e("p", { className: L.TextLight, children: A === 1 ? A + " item" : A + " items" }) })
  ] });
}
var We = /* @__PURE__ */ ((o) => (o[o.None = 0] = "None", o[o.Single = 1] = "Single", o[o.Multi = 2] = "Multi", o))(We || {});
const Ye = new ue("File Explorer", "file-explorer", Ge).setIconUrl("https://os.prozilla.dev/assets/apps/icons/file-explorer.svg").setRole(pe.APP_ROLES.fileExplorer).setCategory("Utilities & tools");
Ye.setMetadata({ name: "@prozilla-os/file-explorer", version: "1.1.15", author: "Prozilla" });
export {
  We as FileSelectorMode,
  Ye as fileExplorer
};
//# sourceMappingURL=main.js.map
